import React, { useState, useEffect, useCallback } from 'react';
import './addorder.scss';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const Addorder = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchtableTitle = useCallback(async (tableId) => {
    try {
      const storedToken = localStorage.getItem('accessToken');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/tables/find/${tableId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          token: `Bearer ${storedToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const shopData = await response.json();
      return shopData.title;
    } catch (error) {
      console.error('Error fetching shop data:', error);
      return 'N/A';
    }
  }, []);

  const updatetableTitles = useCallback(async (orderData) => {
    try {
      const tableTitlePromises = orderData.map(async (order) => {
        const title = await fetchtableTitle(order.tableId);
        return { ...order, tableTitle: title };
      });

      const ordersWithTitles = await Promise.all(tableTitlePromises);
      setRows(ordersWithTitles);
    } catch (error) {
      console.error('Error updating shop titles:', error);
    }
  }, [fetchtableTitle]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const storedToken = localStorage.getItem('accessToken');

        const response = await fetch(`${process.env.REACT_APP_API_URL}/orders`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            token: `Bearer ${storedToken}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setRows(data);
        setLoading(false);

        console.log('orders', data);
        updatetableTitles(data);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchOrders();
  }, [updatetableTitles]);

  return (
    <TableContainer component={Paper} className="reporttable">
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>Order ID</TableCell>
              <TableCell>Table ID</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Created At</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row) => (
              <TableRow key={row._id}>
                <TableCell>{row._id}</TableCell>
                <TableCell>{row.tableId}</TableCell>
                <TableCell>{row.amount}</TableCell>
                <TableCell>{row.createdAt}</TableCell>
                <TableCell>
                  <span className={`status ${row.status ? 'pending' : 'paid'}`}>
                    {row.status ? 'pending' : 'Paid'}
                  </span>
                </TableCell>
                <TableCell>
                  <MoreVertIcon />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
};

export default Addorder;